exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = 357
// module chunks = 1